import * as Yup from 'yup';
import { getDefaultItemId, setDefaultImageFromObj, setDefaultPlateFromObj } from 'src/components/formik-utils';

/**
 * Helper functions for formatting and cleaning input
 */
export const formatWithCommas = (value) => {
  if (!value) return ''; // Handle empty input

  // Remove any non-numeric characters
  const numStr = value.toString().replace(/[^0-9]/g, '');

  switch (numStr.length) {
    case 1:
      return numStr; // 1 => "1"
    case 2:
      return numStr; // 12 => "12"
    case 3:
      return `${numStr.slice(0, 2)}.${numStr.slice(2)}`; // 120 => "12,0"
    case 4:
      return `${numStr.slice(0, 2)}.${numStr.slice(2)}`; // 1203 => "12,03"
    case 5:
      return `${numStr.slice(0, 2)}.${numStr.slice(2)}`; // 12035 => "12,035"
    default:
      return numStr; // Handle numbers longer than 5 characters (if needed)
  }
};
// EOF

export const validationSchema = (item) => {
  const isCreate = !item?.id;
  const isRequired = true; //isCreate || !item.asset;

  let schema = Yup.object();
  schema = schema.shape({
    plateField: Yup.object()
      .nullable()
      .when([], {
        is: () => isCreate,
        then: (schema) => schema.required('Vui lòng chọn Biển Số'),
        otherwise: (schema) => schema.nullable(),
      }),
  });

  schema = schema.shape({
    created: Yup.string()
      .nullable()
      .when([], {
        is: () => isCreate,
        then: (schema) => schema.required('Ngày tiếp nhiên liệu phải có'),
        otherwise: (schema) => schema.nullable(),
      }),
  });

  schema = schema.shape({
    quantity: Yup.number()
      .transform((value, originalValue) => {
        if (typeof originalValue === 'string') {
          return parseFloat(originalValue.replace(/,/g, ''));
        }
        return value;
      })
      .min(1, 'Số lượng phải lớn hơn 1')
      .when([], {
        is: () => isCreate,
        then: (schema) => schema.required('Vui lòng nhập Số Lượng'),
        otherwise: (schema) => schema.nullable(),
      }),
  });

  schema = schema.shape({
    pricingField: Yup.object()
      .nullable()
      .when([], {
        is: () => isCreate,
        then: (schema) => schema.required('Vui lòng chọn Đơn Giá'),
        otherwise: (schema) => schema.nullable(),
      }),
  });

  schema = schema.shape({
    partnerField: Yup.object()
      .nullable()
      .when([], {
        is: () => isCreate,
        then: (schema) => schema.required('Vui lòng chọn Đối Tác'),
        otherwise: (schema) => schema.nullable(),
      }),
  });

  schema = schema.shape({
    image: Yup.string().when([], {
      is: () => isRequired,
      then: (schema) => schema.required('Hình phiếu xăng yêu cầu phải có'),
      otherwise: (schema) => schema.nullable(),
    }),
  });
  
  return schema;
};

export const handleSubmitted = async (
  values,
  item,
  apiCreate,
  apiUpdate,
  apiRemove,
) => {
  const isCreate = !values?.id;
  if (isCreate) {
    if(!values.cardField){
      values.cardField = item.currentCard;
    }
    await apiCreate(values);
  } else {
    if (values.isVerified) {
      await apiRemove(values);
    } else {
      await apiUpdate(values);
    }
  }
};

export const initialValues = (formik, item) => {
  if(!formik) return;
  const myId = getDefaultItemId(item);

  if(0 < myId){
    formik.setFieldValue('id', myId);
    // formik.setFieldValue('created', null);

    // formik.setFieldValue('myCarId', item.car?.id || '');
    // formik.setFieldValue('note', item.note || '');

    setDefaultPlateFromObj(formik, item.car);
    setDefaultImageFromObj(formik, item.asset);
  }else{
    // formik.setFieldValue('created', Date.now());
    formik.setFieldValue('quantity', null);
    formik.setFieldValue('partnerField', null);
    formik.setFieldValue('pricingField', null);
  }
};
